// extracted by css-extract-rspack-plugin
export default {"cls1":"QuestionStyles-cls1_xHV","cls2":"QuestionStyles-cls2_46L QuestionStyles-cls1_xHV"};